class Flag {
  constructor(key, data) {
    this.key = key;
    this.variation = data.variation;
    this.isEnabled =
      data.isEnabled !== undefined ? !!data.isEnabled : !!data.variation;
    this.abTest = data.abTest || data.isAbTest || false;
  }
}

module.exports = Flag;
